export const labels = {
  WORKING: '已连接',
  STOPPED: '已停止',
  STARTING: '启动中',
  SCAN_QR_CODE: '等待扫码',
  FAILED: '连接失败',
  UNKNOWN: '状态未知',
  AVAILABLE: '可用',
  UNTESTED: '未测试',
  EXIT_CHANGED: '出口已变化',
};
export const statusText = (value) => labels[value] || value || '—';
export const deletionText = (session) =>
  session.deletion?.status === 'NEEDS_REVIEW'
    ? '删除待核对'
    : {
        REQUESTED: '删除准备 · 校验与备份',
        APPROVED: '准备清理收件箱',
        INBOX: '清理收件箱与后台任务',
        NODE_QUEUED: '清理节点与登录数据',
        NODE_REMOVED: '清理账号记录',
        DONE: '已删除',
      }[session.deletion?.phase] || '删除处理中';
export const onboardingText = (session) =>
  (({
    QUEUED: '等待自动开通',
    PROVISIONING: '正在创建隔离节点并验证出口',
    WAITING_QR: '节点已就绪，请扫码',
    CREATING_INBOX: '正在自动创建专属收件箱',
    CONFIGURING_APP: '正在启用消息集成',
    COMPLETE: '自动开通完成',
    NEEDS_REVIEW: '开通待核对',
    CANCELLED: '已取消开通',
  })[session.onboarding?.stage] || '待部署 · 配置已保存') +
  (session.onboarding?.error ? ` · ${session.onboarding.error}` : '');
export function historyText(session) {
  const history = session.history;
  if (!history?.default_enabled) return '历史同步未启用';
  const progress = history.progress || {};
  const text =
    {
      WAITING_CONNECTION: '等待账号连接',
      WAITING_INTEGRATION: '等待收件箱集成启用',
      WAITING: '准备分阶段导入',
      SUBMITTING: '正在提交历史任务',
      IMPORTING: '历史导入中',
      COMPLETED: '本轮可用历史导入完成',
      WATCHING: '本轮可用历史已导入，后台补查中',
      PARTIAL: '存在失败记录，后台继续补查',
      FAILED: '历史导入失败，待核对',
      NEEDS_REVIEW: '历史任务待核对',
    }[history.status] || '历史同步待核对';
  return (
    text +
    (progress.ok === undefined
      ? ''
      : ` · 导入 ${progress.ok} 条 · 跳过 ${progress.exists ?? 0} 次 · 失败 ${progress.errors ?? 0} 次`)
  );
}
